module.exports = __webpack_public_path__ + "static/img/no-data.d120735e.png";